import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import { updateLineItem } from "MODULES/PurchaseOrders/actions";
import ConfirmAction from "MODULES/shared/components/ConfirmAction";
import Exchange from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Exchange/Exchange";
import { ADMIN, QUALITY_CONTROL } from "MODULES/users/constants";
import Outright from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Outright/Outright";
import ReverseExchange from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/ReverseExchange/ReverseExchange";
import CancelModal from "./CancelModal";

export function LineItemControls({
  update,
  lineItem,
  currentUser,
  purchaseOrder
}) {
  const { id: userId, role } = currentUser;
  const { buyer: { id: buyerId, co_buyer_id: coBuyerId } } = purchaseOrder;
  const userCanEdit =
    role === ADMIN ||
    role === QUALITY_CONTROL ||
    userId === buyerId ||
    userId === coBuyerId;
  const showControls = userCanEdit || lineItem.purchase_for_exchange;

  if (!showControls) return null;

  return (
    <div>
      <DropDown>
        <DropDownItem
          id="cancel"
          label="Cancel Line Item"
          faIcon="ban"
          hideIf={lineItem.cancelled || lineItem.received || !userCanEdit}
          renderActive={<CancelModal lineItem={lineItem} />}
        />
        <DropDownItem
          id="uncancel"
          label="Reverse Cancellation"
          faIcon="undo"
          hideIf={!lineItem.cancelled || !userCanEdit}
          renderActive={
            <ConfirmAction
              onConfirm={() =>
                update(lineItem.id, { cancelled: !lineItem.cancelled })}
              message="Are you sure you want to reopen this item?"
            />
          }
        />
        <Exchange key="create-exchange" lineItem={lineItem} />
        <ReverseExchange lineItem={lineItem} />
        <Outright lineItem={lineItem} />
      </DropDown>
    </div>
  );
}

LineItemControls.propTypes = {
  lineItem: PropTypes.shape({}).isRequired,
  update: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.instanceOf(Object),
  currentUser: PropTypes.instanceOf(Object)
};

export default connect(
  state => ({
    currentUser: state.session.get("user").toJS(),
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder").toJS()
  }),
  dispatch => ({
    update: (id, data) => dispatch(updateLineItem(id, data))
  })
)(LineItemControls);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/LineItemControls.jsx